import { render, staticRenderFns } from "./AskAiButton.vue?vue&type=template&id=16ee16d6&scoped=true"
import script from "./AskAiButton.vue?vue&type=script&lang=js"
export * from "./AskAiButton.vue?vue&type=script&lang=js"
import style0 from "./AskAiButton.vue?vue&type=style&index=0&id=16ee16d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16ee16d6",
  null
  
)

export default component.exports